import { useSelector } from "react-redux";
import { selectSiteLang } from "../../../../store/userSlice";
import { FormatPrice } from "../../../../utils/generalUtils";
import { Check, Plus } from "../../../Icons";
import style from "./index.module.css";

const ClassDifferences = ({ differences, priceDiff }: ComponentPropsType) => {
  const siteLang = useSelector(selectSiteLang);
  return (
    <div className={`${style.all_equipment} row`}>
      {differences.map((diff, index) => (
        <div key={index} className={`${style.single_equipment} col-md-4 col-6`}>
          <Check width="17" height="17" color="#2f2f2f" />
          <span>{diff}</span>
        </div>
      ))}
      <div className={`${style.single_equipment} col-md-4 col-6`}>
        <Plus width="17" height="17" color="#dc0000" />
        <span style={{ color: "#dc0000" }}>
          <FormatPrice value={priceDiff} />
        </span>
      </div>
    </div>
  );
};

export default ClassDifferences;

export type ClassDifferencesType = string[];

type ComponentPropsType = {
  differences: ClassDifferencesType;
  priceDiff: number;
};
